// src/Counter.js
import React, { useState, useEffect } from 'react';

const Counter = ({ end, description }) => {
  const [count, setCount] = useState(0);

  const resetCounter = () => {
    setCount(0);
    let start = 0;
    const duration = 2000;
    const increment = end / (duration / 10);

    const counterInterval = setInterval(() => {
      start += increment;
      if (start >= end) {
        clearInterval(counterInterval);
        setCount(end);
      } else {
        setCount(Math.ceil(start));
      }
    }, 10);
  };

  useEffect(() => {
    let observer;
    const element = document.getElementById(description.replace(/\s+/g, ''));
    const observerCallback = (entries) => {
      if (entries[0].isIntersecting) {
        resetCounter();
      }
    };

    observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (observer && element) {
        observer.unobserve(element);
      }
    };
  }, [end, description]);

  return (
    <div id={description.replace(/\s+/g, '')} className="counter">
      <h2>{count}+</h2>
      <p>{description}</p>
    </div>
  );
};

export default Counter;
